export const NotificationsSheetTestIds = {
  DRAWER: 'notifications-sheet.drawer',
};
